<template>
  <div class="button-container">
    <b-button :href="href" class="button">
      {{ label }}
      <i v-if="icon" :class="`bi bi-${icon} icon`" />
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'button-component',
  props: {
    href: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 5px;
}

.button {
  background: #1e2b5a;
  width: 50%;

  @media (max-width: 780px) {
    width: 100%;
  }
}

.button:hover {
  background: #2b3c7a;
}

.icon {
  margin-left: 10px;
}
</style>
